import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";
import AddDevice from "./views/AddDevice/AddDevice.vue";
import AddNode10 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode10/AddNode10.vue";
import AddNode11 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode11/AddNode11.vue";
import AddNode14 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode14/AddNode14.vue";
import AddNode15 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode15/AddNode15.vue";
import AddNode16 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode16/AddNode16.vue";
import AddNode17 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode17/AddNode17.vue";
import AddNode18 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode18/AddNode18.vue";
import AddNode2 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode2/AddNode2.vue";
import AddNode3 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode3/AddNode3.vue";
import AddNode4 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode4/AddNode4.vue";
import AddNode5 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode5/AddNode5.vue";
import AddNode6 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode6/AddNode6.vue";
import AddNode7 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode7/AddNode7.vue";
import AddNode8 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode8/AddNode8.vue";
import AddNode9 from "./views/AddDevice/AddNewDevice/AddDevice/AddNode9/AddNode9.vue";
import AddNodeHubNotFound from "./views/AddDevice/AddNewDevice/AddDevice/HubNotFound.vue";
import AddNodeNameColor from "./views/AddDevice/AddNewDevice/AddDevice/NameColor.vue";
import AddNodeSelectHub from "./views/AddDevice/AddNewDevice/AddDevice/SelectHub.vue";
import AddNodeSuccess from "./views/AddDevice/AddNewDevice/AddDevice/Success.vue";
import AddHub from "./views/AddDevice/AddNewDevice/AddHub/AddHub.vue";
import AddHubConnectWifi from "./views/AddDevice/AddNewDevice/AddHub/ConnectWifi.vue";
import AddHubNotFound from "./views/AddDevice/AddNewDevice/AddHub/HubNotFound.vue";
import AddHubReset from "./views/AddDevice/AddNewDevice/AddHub/HubReset.vue";
import AddHubLedCheck from "./views/AddDevice/AddNewDevice/AddHub/LedCheck.vue";
import AddHubLedError from "./views/AddDevice/AddNewDevice/AddHub/LedError.vue";
import AddHubNameColor from "./views/AddDevice/AddNewDevice/AddHub/NameColor.vue";
import AddHubSecurity from "./views/AddDevice/AddNewDevice/AddHub/Security.vue";
import AddHubSetPassword from "./views/AddDevice/AddNewDevice/AddHub/SetPassword.vue";
import AddHubSuccess from "./views/AddDevice/AddNewDevice/AddHub/Success.vue";
import AddHubTurnOn from "./views/AddDevice/AddNewDevice/AddHub/TurnOn.vue";
import AddNewDevice from "./views/AddDevice/AddNewDevice/AddNewDevice.vue";
import AddNewDeviceDuplicated from "./views/AddDevice/AddNewDevice/DuplicatedDevice.vue";
import AddNewDeviceNoHub from "./views/AddDevice/AddNewDevice/NoHub.vue";
import AddNewDeviceScanQR from "./views/AddDevice/AddNewDevice/ScanQR.vue";
import AddNewDeviceUploadQR from "./views/AddDevice/AddNewDevice/UploadQR.vue";
import DeleteDevice from "./views/DeleteDevice/DeleteDevice.vue";
import DeleteHub from "./views/DeleteDevice/DeleteHub.vue";
import DeleteUser from "./views/DeleteDevice/DeleteUser.vue";
import DeleteDeviceHubError from "./views/DeleteDevice/HubError.vue";
import DeleteDeviceSuccess from "./views/DeleteDevice/Success.vue";
import AddNewWidget from "./views/Home/DashBoard/AddNewWidget.vue";
import DashBoard from "./views/Home/DashBoard/DashBoard.vue";
import AddAcRemoteWidget from "./views/Home/DashBoard/Settings/AcRemoteWidget/Add.vue";
import EditAcRemoteWidget from "./views/Home/DashBoard/Settings/AcRemoteWidget/Edit.vue";
import AddDoubleSwitchWidget from "./views/Home/DashBoard/Settings/DoubleSwitchWidget/Add.vue";
import EditDoubleSwitchWidget from "./views/Home/DashBoard/Settings/DoubleSwitchWidget/Edit.vue";
import AddFolderWidget from "./views/Home/DashBoard/Settings/FolderWidget/Add.vue";
import EditFolderWidget from "./views/Home/DashBoard/Settings/FolderWidget/Edit.vue";
import AddHumidityWidget from "./views/Home/DashBoard/Settings/HumidityWidget/Add.vue";
import EditHumidityWidget from "./views/Home/DashBoard/Settings/HumidityWidget/Edit.vue";
import AddRGBWWidget from "./views/Home/DashBoard/Settings/RGBWWidget/Add.vue";
import EditRGBWWidget from "./views/Home/DashBoard/Settings/RGBWWidget/Edit.vue";
import RGBWWidgetPalette from "./views/Home/DashBoard/Settings/RGBWWidget/Palette.vue";
import AddS1TouchWidget from "./views/Home/DashBoard/Settings/S1TouchWidget/Add.vue";
import EditS1TouchWidget from "./views/Home/DashBoard/Settings/S1TouchWidget/Edit.vue";
import AddSceneButtonWidget from "./views/Home/DashBoard/Settings/SceneButtonWidget/Add.vue";
import EditSceneButtonWidget from "./views/Home/DashBoard/Settings/SceneButtonWidget/Edit.vue";
import AddSchedules from "./views/Home/DashBoard/Settings/Schedules/Add.vue";
import EditSchedule from "./views/Home/DashBoard/Settings/Schedules/Edit.vue";
import Schedules from "./views/Home/DashBoard/Settings/Schedules/Schedules.vue";
import AddScheduleSuccess from "./views/Home/DashBoard/Settings/Schedules/Success.vue";
import AddSingleSwitchWidget from "./views/Home/DashBoard/Settings/SingleSwitchWidget/Add.vue";
import EditSingleSwitchWidget from "./views/Home/DashBoard/Settings/SingleSwitchWidget/Edit.vue";
import AddSingleThreewaySwitchWidget from "./views/Home/DashBoard/Settings/SingleThreewaySwitchWidget/Add.vue";
import EditSingleThreewaySwitchWidget from "./views/Home/DashBoard/Settings/SingleThreewaySwitchWidget/Edit.vue";
import AddSmartCurtainWidget from "./views/Home/DashBoard/Settings/SmartCurtainWidget/Add.vue";
import EditSmartCurtainWidget from "./views/Home/DashBoard/Settings/SmartCurtainWidget/Edit.vue";
import AddTemperatureAutomationWidget from "./views/Home/DashBoard/Settings/TemperatureAutomationWidget/Add.vue";
import EditTemperatureAutomationWidget from "./views/Home/DashBoard/Settings/TemperatureAutomationWidget/Edit.vue";
import AddTemperatureWidget from "./views/Home/DashBoard/Settings/TemperatureWidget/Add.vue";
import EditTemperatureWidget from "./views/Home/DashBoard/Settings/TemperatureWidget/Edit.vue";
import AddTvRemoteWidget from "./views/Home/DashBoard/Settings/TvRemoteWidget/Add.vue";
import EditTvRemoteWidget from "./views/Home/DashBoard/Settings/TvRemoteWidget/Edit.vue";
import Devices from "./views/Home/Devices/Devices.vue";
import AddNewUser from "./views/Home/Devices/Settings/Hub/AddNewUser.vue";
import AddNewUserGoogle from "./views/Home/Devices/Settings/Hub/AddNewUserGoogle.vue";
import EditUser from "./views/Home/Devices/Settings/Hub/EditUser.vue";
import HubNetworkSettings from "./views/Home/Devices/Settings/Hub/NetworkSettings.vue";
import NetworkSettingsSuccess from "./views/Home/Devices/Settings/Hub/NetworkSettingsSuccess.vue";
import NewUserCredentials from "./views/Home/Devices/Settings/Hub/NewUserCredentials.vue";
import OTA from "./views/Home/Devices/Settings/Hub/OTA.vue";
import OtaSuccess from "./views/Home/Devices/Settings/Hub/OtaSuccess.vue";
import SelectAddNewUserType from "./views/Home/Devices/Settings/Hub/SelectAddNewUserType.vue";
import HubSettings from "./views/Home/Devices/Settings/Hub/Settings.vue";
import HubUserSettings from "./views/Home/Devices/Settings/Hub/UserSettings.vue";
import SettingsHubError from "./views/Home/Devices/Settings/HubError.vue";
import InputHumiditySensorSettings from "./views/Home/Devices/Settings/Inputs/HumiditySensor/Settings.vue";
import InputTemperatureSensorSettings from "./views/Home/Devices/Settings/Inputs/TemperatureSensor/Settings.vue";
import InputZeroContactSettings from "./views/Home/Devices/Settings/Inputs/ZeroContact/Settings.vue";
import Node10Settings from "./views/Home/Devices/Settings/Node10/Settings.vue";
import Node11Settings from "./views/Home/Devices/Settings/Node11/Settings.vue";
import Node13Settings from "./views/Home/Devices/Settings/Node13/Settings.vue";
import Node14Settings from "./views/Home/Devices/Settings/Node14/Settings.vue";
import Node15Settings from "./views/Home/Devices/Settings/Node15/Settings.vue";
import Node16Settings from "./views/Home/Devices/Settings/Node16/Settings.vue";
import Node17Settings from "./views/Home/Devices/Settings/Node17/Settings.vue";
import Node18Settings from "./views/Home/Devices/Settings/Node18/Settings.vue";
import Node2Settings from "./views/Home/Devices/Settings/Node2/Settings.vue";
import Node2SettingsSuccess from "./views/Home/Devices/Settings/Node2/Success.vue";
import Node3Settings from "./views/Home/Devices/Settings/Node3/Settings.vue";
import Node4Settings from "./views/Home/Devices/Settings/Node4/Settings.vue";
import Node5Settings from "./views/Home/Devices/Settings/Node5/Settings.vue";
import Node6Settings from "./views/Home/Devices/Settings/Node6/Settings.vue";
import AddIrDevice from "./views/Home/Devices/Settings/Node7/AddIrDevice.vue";
import Node7Settings from "./views/Home/Devices/Settings/Node7/Settings.vue";
import ShowIrRemote from "./views/Home/Devices/Settings/Node7/ShowIrRemote.vue";
import AddRfDevice from "./views/Home/Devices/Settings/Node8/AddRfDevice.vue";
import Node8Settings from "./views/Home/Devices/Settings/Node8/Settings.vue";
import ShowRfRemote from "./views/Home/Devices/Settings/Node8/ShowRfRemote.vue";
import Node9Settings from "./views/Home/Devices/Settings/Node9/Settings.vue";
import SettingsNodeError from "./views/Home/Devices/Settings/NodeError.vue";
import OutputColorPwmSettings from "./views/Home/Devices/Settings/Outputs/ColorPwm/Settings.vue";
import OutputIrDeviceSettings from "./views/Home/Devices/Settings/Outputs/IrDevice/Settings.vue";
import OutputRgbSettings from "./views/Home/Devices/Settings/Outputs/RGB/Settings.vue";
import OutputRelaySSR2ASettings from "./views/Home/Devices/Settings/Outputs/RelaySSR2A/Settings.vue";
import OutputRfDeviceSettings from "./views/Home/Devices/Settings/Outputs/RfDevice/Settings.vue";
import Home from "./views/Home/Home.vue";
import Settings from "./views/Home/Settings/Settings.vue";
import LanguageSelect from "./views/LanguageSelect/LanguageSelect.vue";
import LoginConfirmationCode from "./views/LoginRegister/LoginConfirmationCode.vue";
import LoginRegister from "./views/LoginRegister/LoginRegister.vue";
import LuxinIntro from "./views/LuxinIntro/LuxinIntro.vue";
import PairNodeHubNotResponding from "./views/PairDevice/HubNotResponding.vue";
import PairNodeNodeNotResponding from "./views/PairDevice/NodeNotResponding.vue";
import PairNode from "./views/PairDevice/PairNode.vue";
import PairNodeSuccess from "./views/PairDevice/Success.vue";
import Story from "./views/Story.vue";
// import DeleteScenario from './views/DeleteDevice/DeleteScenario.vue'
import * as CONFIGS from "@/statics/configs.js";
import HubLogin from "./views/AddDevice/AddNewDevice/AddHub/HubLogin.vue";
import AddRGBStandAlone from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/AddRGBStandAlone.vue";
import AddRGBStandAloneConnectWifi from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/ConnectWifi.vue";
import AddRGBStandAloneLedCheck from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/LedCheck.vue";
import AddRGBStandAloneLedError from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/LedError.vue";
import AddRGBStandAloneNameColor from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/NameColor.vue";
import AddRGBStandAloneSecurity from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/Security.vue";
import AddRGBStandAloneSetPassword from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/SetPassword.vue";
import AddRGBStandAloneNotFound from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/StandAloneNotFound.vue";
import AddRGBStandAloneReset from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/StandAloneReset.vue";
import AddRGBStandAloneSuccess from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/Success.vue";
import AddRGBStandAloneTurnOn from "./views/AddDevice/AddNewDevice/AddRGBStandAlone/TurnOn.vue";
import DeleteFolderWidget from "./views/DeleteDevice/DeleteFolderWidget.vue";
import DeleteIrDevice from "./views/DeleteDevice/DeleteIrDevice.vue";
import DeleteRfDevice from "./views/DeleteDevice/DeleteRfDevice.vue";
import DeleteSchedule from "./views/DeleteDevice/DeleteSchedule.vue";
import DeleteTemperatureAutomation from "./views/DeleteDevice/DeleteTemperatureAutomation.vue";
import DeleteWidget from "./views/DeleteDevice/DeleteWidget.vue";
import HubLoginError from "./views/Home/Devices/Settings/Hub/HubLoginError.vue";
import HubLoginNotFound from "./views/Home/Devices/Settings/Hub/HubLoginNotFound.vue";
import HubLoginSuccess from "./views/Home/Devices/Settings/Hub/HubLoginSuccess.vue";
import LogOut from "./views/Home/Settings/LogOut.vue";
import IrCodeConvertor from "./views/utils/IrCodeConvertor.vue";
import ParameterSetter from "./views/utils/ParameterSetter.vue";
import RfTester from "./views/utils/RfTester.vue";

Vue.use(Router);

store.commit("setAppBusy", true);
if (store.getters.isStateSaved) {
  store.commit("loadState");
}
if (CONFIGS.APP_MODE == "phonegap") {
  document.addEventListener(
    "deviceready",
    function () {
      console.log("deviceready");
      store.dispatch("init");
    },
    false
  );
} else {
  store.dispatch("init");
}
// store.dispatch('init');

export default new Router({
  routes: [
    {
      path: "/",
      name: "story",
      component: Story,
      beforeEnter: function (to, from, next) {
        if (store.state.user.loggedIn) {
          if (store.state.user.isIntroTaken) {
            next({ path: "/home/dashboard/0" });
          } else {
            next({ path: "/luxinIntro" });
          }
        } else {
          next({ path: "/languageSelect" });
        }
      },
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      children: [
        {
          path: "/home/dashboard/:folderId*",
          name: "dashboard",
          component: DashBoard,
          beforeEnter: function (to, from, next) {
            if (!store.state.user.loggedIn || !store.state.user.isIntroTaken) {
              next({ path: "/" });
            } else {
              if (to.params.folderId === undefined) {
                next({ path: "/home/dashboard/" + store.state.activeDashboardFolderId });
              } else {
                next();
              }
            }
          },
        },
        {
          path: "/home/devices",
          name: "devices",
          component: Devices,
          beforeEnter: function (to, from, next) {
            if (!store.state.user.loggedIn || !store.state.user.isIntroTaken) {
              next({ path: "/" });
            } else {
              next();
            }
          },
        },
        {
          path: "/home/settings",
          name: "settings",
          component: Settings,
          beforeEnter: function (to, from, next) {
            if (!store.state.user.loggedIn || !store.state.user.isIntroTaken) {
              next({ path: "/" });
            } else {
              next();
            }
          },
        },
      ],
    },
    {
      path: "/languageSelect",
      name: "languageselect",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
      component: LanguageSelect,
    },
    {
      path: "/loginRegister",
      name: "loginRegister",
      component: LoginRegister,
      beforeEnter: function (to, from, next) {
        if (store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/loginConfirmationCode",
      name: "loginConfirmationCode",
      component: LoginConfirmationCode,
      beforeEnter: function (to, from, next) {
        if (store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (store.state.user.uuid === null) {
          next({ path: "/loginRegister" });
        } else {
          next();
        }
      },
    },
    {
      path: "/luxinIntro",
      name: "luxinIntro",
      component: LuxinIntro,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addDevice",
      name: "addDevice",
      component: AddDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNewDevice",
      name: "addNewDevice",
      component: AddNewDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNewDeviceScanQR",
      name: "addNewDeviceScanQR",
      component: AddNewDeviceScanQR,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddNewDeviceUploadQR",
      name: "AddNewDeviceUploadQR",
      component: AddNewDeviceUploadQR,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNewDeviceNoHub",
      name: "addNewDeviceNoHub",
      component: AddNewDeviceNoHub,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNewDeviceDuplicated",
      name: "addNewDeviceDuplicated",
      component: AddNewDeviceDuplicated,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub",
      name: "addHub",
      component: AddHub,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone",
      name: "AddRGBStandAlone",
      component: AddRGBStandAlone,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-TurnOn",
      name: "addHub-TurnOn",
      component: AddHubTurnOn,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addRGBStandAlone-TurnOn",
      name: "addRGBStandAlone-TurnOn",
      component: AddRGBStandAloneTurnOn,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-LedCheck",
      name: "addHub-LedCheck",
      component: AddHubLedCheck,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addRGBStandAlone-LedCheck",
      name: "addRGBStandAlone-LedCheck",
      component: AddRGBStandAloneLedCheck,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-LedError",
      name: "addHub-LedError",
      component: AddHubLedError,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addRGBStandAlone-LedError",
      name: "addRGBStandAlone-LedError",
      component: AddRGBStandAloneLedError,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-Reset",
      name: "addHub-Reset",
      component: AddHubReset,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-Reset",
      name: "AddRGBStandAlone-Reset",
      component: AddRGBStandAloneReset,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-Security",
      name: "addHub-Security",
      component: AddHubSecurity,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-Security",
      name: "AddRGBStandAlone-Security",
      component: AddRGBStandAloneSecurity,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-SetPassword",
      name: "addHub-SetPassword",
      component: AddHubSetPassword,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-SetPassword",
      name: "AddRGBStandAlone-SetPassword",
      component: AddRGBStandAloneSetPassword,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-NameColor",
      name: "addHub-NameColor",
      component: AddHubNameColor,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else if (!store.state.tempHub.password) {
          next({ path: "/AddHub-Security" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-NameColor",
      name: "AddRGBStandAlone-NameColor",
      component: AddRGBStandAloneNameColor,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else if (!store.state.tempHub.password) {
          next({ path: "/AddRGBStandAlone-Security" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-ConnectWifi",
      name: "addHub-ConnectWifi",
      component: AddHubConnectWifi,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else if (!store.state.tempHub.password) {
          next({ path: "/AddHub-Security" });
        } else if (!store.state.tempHub.name || (!store.state.tempHub.color && store.state.tempHub.color != 0)) {
          next({ path: "/AddHub-NameColor" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-ConnectWifi",
      name: "AddRGBStandAlone-ConnectWifi",
      component: AddRGBStandAloneConnectWifi,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else if (!store.state.tempHub.password) {
          next({ path: "/AddRGBStandAlone-Security" });
        } else if (!store.state.tempHub.name || (!store.state.tempHub.color && store.state.tempHub.color != 0)) {
          next({ path: "/AddRGBStandAlone-NameColor" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-NotFound",
      name: "addHub-NotFound",
      component: AddHubNotFound,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else if (!store.state.tempHub.password) {
          next({ path: "/AddHub-Security" });
        } else if (!store.state.tempHub.name || (!store.state.tempHub.color && store.state.tempHub.color != 0)) {
          next({ path: "/AddHub-NameColor" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-NotFound",
      name: "AddRGBStandAlone-NotFound",
      component: AddRGBStandAloneNotFound,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else if (!store.state.tempHub.password) {
          next({ path: "/AddRGBStandAlone-Security" });
        } else if (!store.state.tempHub.name || (!store.state.tempHub.color && store.state.tempHub.color != 0)) {
          next({ path: "/AddRGBStandAlone-NameColor" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addHub-Success",
      name: "addHub-Success",
      component: AddHubSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBStandAlone-Success",
      name: "AddRGBStandAlone-Success",
      component: AddRGBStandAloneSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-2",
      name: "addNode-2",
      component: AddNode2,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-18",
      name: "addNode-18",
      component: AddNode18,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-3",
      name: "addNode-3",
      component: AddNode3,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-4",
      name: "addNode-4",
      component: AddNode4,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-5",
      name: "addNode-5",
      component: AddNode5,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-11",
      name: "addNode-11",
      component: AddNode11,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-6",
      name: "addNode-6",
      component: AddNode6,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-7",
      name: "addNode-7",
      component: AddNode7,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-8",
      name: "addNode-8",
      component: AddNode8,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-9",
      name: "addNode-9",
      component: AddNode9,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-10",
      name: "addNode-10",
      component: AddNode10,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-14",
      name: "addNode-14",
      component: AddNode14,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-15",
      name: "addNode-15",
      component: AddNode15,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-16",
      name: "addNode-16",
      component: AddNode16,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-17",
      name: "addNode-17",
      component: AddNode17,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },

    {
      path: "/addNode-SelectHub",
      name: "addNode-SelectHub",
      component: AddNodeSelectHub,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-NameColor",
      name: "addNode-NameColor",
      component: AddNodeNameColor,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else if (!store.state.scannedQR || (!store.state.tempNode.hubIndex && store.state.tempNode.hubIndex != 0)) {
          next({ path: "/home/devices" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-Success",
      name: "addNode-Success",
      component: AddNodeSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/addNode-HubNotFound",
      name: "addNode-HubNotFound",
      component: AddNodeHubNotFound,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/pairNode/:nodeUUID",
      name: "pairNode",
      component: PairNode,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/pairNode-Success",
      name: "pairNode-Success",
      component: PairNodeSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/pairNode-HubNotResponding/:nodeUUID",
      name: "pairNode-HubNotResponding",
      component: PairNodeHubNotResponding,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/pairNode-NodeNotResponding/:nodeUUID",
      name: "pairNode-NodeNotResponding",
      component: PairNodeNodeNotResponding,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node2Settings/:nodeUUID",
      name: "Node2Settings",
      component: Node2Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node18Settings/:nodeUUID",
      name: "Node18Settings",
      component: Node18Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node3Settings/:nodeUUID",
      name: "Node3Settings",
      component: Node3Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node4Settings/:nodeUUID",
      name: "Node4Settings",
      component: Node4Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node5Settings/:nodeUUID",
      name: "Node5Settings",
      component: Node5Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node6Settings/:nodeUUID",
      name: "Node6Settings",
      component: Node6Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node7Settings/:nodeUUID",
      name: "Node7Settings",
      component: Node7Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node8Settings/:nodeUUID",
      name: "Node8Settings",
      component: Node8Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node9Settings/:nodeUUID",
      name: "Node9Settings",
      component: Node9Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node10Settings/:nodeUUID",
      name: "Node10Settings",
      component: Node10Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node11Settings/:nodeUUID",
      name: "Node11Settings",
      component: Node11Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node13Settings/:nodeUUID",
      name: "Node13Settings",
      component: Node13Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node14Settings/:nodeUUID",
      name: "Node14Settings",
      component: Node14Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node15Settings/:nodeUUID",
      name: "Node15Settings",
      component: Node15Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node16Settings/:nodeUUID",
      name: "Node16Settings",
      component: Node16Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node17Settings/:nodeUUID",
      name: "Node17Settings",
      component: Node17Settings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },

    {
      path: "/AddIrDevice/:nodeUUID",
      name: "AddIrDevice",
      component: AddIrDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRfDevice/:nodeUUID",
      name: "AddRfDevice",
      component: AddRfDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/ShowIrRemote/:nodeUUID/:outputIndex",
      name: "ShowIrRemote",
      component: ShowIrRemote,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/ShowRfRemote/:nodeUUID/:outputIndex",
      name: "ShowRfRemote",
      component: ShowRfRemote,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Node2SettingsSuccess",
      name: "Node2SettingsSuccess",
      component: Node2SettingsSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    // {
    //   path: "/Node18SettingsSuccess",
    //   name: "Node18SettingsSuccess",
    //   component: Node18SettingsSuccess,
    //   beforeEnter: function (to, from, next) {
    //     if (!store.state.user.loggedIn) {
    //       next({ path: "/" });
    //     } else {
    //       next();
    //     }
    //   },
    // },
    {
      path: "/SettingsHubError",
      name: "SettingsHubError",
      component: SettingsHubError,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/SettingsNodeError",
      name: "SettingsNodeError",
      component: SettingsNodeError,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteDevice/:nodeUUID",
      name: "DeleteDevice",
      component: DeleteDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteDeviceSuccess",
      name: "DeleteDeviceSuccess",
      component: DeleteDeviceSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteDeviceHubError",
      name: "DeleteDeviceHubError",
      component: DeleteDeviceHubError,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/InputZeroContactSettings/:nodeUUID/:inputIndex",
      name: "InputZeroContactSettings",
      component: InputZeroContactSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OutputRelaySSR2ASettings/:nodeUUID/:outputIndex",
      name: "OutputRelaySSR2ASettings",
      component: OutputRelaySSR2ASettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OutputRgbSettings/:nodeUUID/:outputIndex",
      name: "OutputRgbSettings",
      component: OutputRgbSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OutputColorPwmSettings/:nodeUUID/:outputIndex",
      name: "OutputColorPwmSettings",
      component: OutputColorPwmSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OutputIrDeviceSettings/:nodeUUID/:outputIndex",
      name: "OutputIrDeviceSettings",
      component: OutputIrDeviceSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OutputRfDeviceSettings/:nodeUUID/:outputIndex",
      name: "OutputRfDeviceSettings",
      component: OutputRfDeviceSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/InputTemperatureSensorSettings/:nodeUUID/:inputIndex",
      name: "InputTemperatureSensorSettings",
      component: InputTemperatureSensorSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/InputHumiditySensorSettings/:nodeUUID/:inputIndex",
      name: "InputHumiditySensorSettings",
      component: InputHumiditySensorSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubSettings/:hubUUID",
      name: "HubSettings",
      component: HubSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteHub/:hubUUID",
      name: "DeleteHub",
      component: DeleteHub,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OTA/:hubUUID",
      name: "OTA",
      component: OTA,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/OtaSuccess",
      name: "OtaSuccess",
      component: OtaSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubNetworkSettings/:hubUUID",
      name: "HubNetworkSettings",
      component: HubNetworkSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/NetworkSettingsSuccess",
      name: "NetworkSettingsSuccess",
      component: NetworkSettingsSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubUserSettings/:hubUUID",
      name: "HubUserSettings",
      component: HubUserSettings,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditUser/:hubUUID/:userIndex",
      name: "EditUser",
      component: EditUser,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddNewUser/:hubUUID",
      name: "AddNewUser",
      component: AddNewUser,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddNewUserGoogle/:hubUUID",
      name: "AddNewUserGoogle",
      component: AddNewUserGoogle,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/SelectAddNewUserType/:hubUUID",
      name: "SelectAddNewUserType",
      component: SelectAddNewUserType,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/NewUserCredentials/:hubUUID/:password",
      name: "NewUserCredentials",
      component: NewUserCredentials,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteUser/:hubUUID/:userIndex",
      name: "DeleteUser",
      component: DeleteUser,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    // {
    //   path: '/DeleteScenario/:scenarioIndex',
    //   name: 'DeleteScenario',
    //   component: DeleteScenario,
    //   beforeEnter: function (to, from, next) {
    //     if( !store.state.user.loggedIn ){
    //       next({ path: '/' });
    //     }else{
    //       next();
    //     }
    //   }
    // },
    {
      path: "/DeleteWidget/:widgetIndex",
      name: "DeleteWidget",
      component: DeleteWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteTemperatureAutomation/:widgetIndex",
      name: "DeleteTemperatureAutomation",
      component: DeleteTemperatureAutomation,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteFolderWidget/:widgetIndex",
      name: "DeleteFolderWidget",
      component: DeleteFolderWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteSchedule/:hubUUID/:eventIdToWatch",
      name: "DeleteSchedule",
      component: DeleteSchedule,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteIrDevice/:nodeUUID/:outputIndex",
      name: "DeleteIrDevice",
      component: DeleteIrDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/DeleteRfDevice/:nodeUUID/:outputIndex",
      name: "DeleteRfDevice",
      component: DeleteRfDevice,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubLogin",
      name: "HubLogin",
      component: HubLogin,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubLoginSuccess",
      name: "HubLoginSuccess",
      component: HubLoginSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubLoginNotFound",
      name: "HubLoginNotFound",
      component: HubLoginNotFound,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/HubLoginError",
      name: "HubLoginError",
      component: HubLoginError,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/LogOut",
      name: "LogOut",
      component: LogOut,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    // {
    //   path: '/AddScenario',
    //   name: 'AddScenario',
    //   component: AddScenario,
    //   beforeEnter: function (to, from, next) {
    //     if( !store.state.user.loggedIn ){
    //       next({ path: '/' });
    //     }else{
    //       next();
    //     }
    //   }
    // },
    // {
    //   path: '/EditScenario/:scenarioIndex',
    //   name: 'EditScenario',
    //   component: EditScenario,
    //   beforeEnter: function (to, from, next) {
    //     if( !store.state.user.loggedIn ){
    //       next({ path: '/' });
    //     }else{
    //       next();
    //     }
    //   }
    // },
    {
      path: "/EditSingleSwitchWidget/:widgetIndex",
      name: "EditSingleSwitchWidget",
      component: EditSingleSwitchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditS1TouchWidget/:widgetIndex",
      name: "EditS1TouchWidget",
      component: EditS1TouchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditDoubleSwitchWidget/:widgetIndex",
      name: "EditDoubleSwitchWidget",
      component: EditDoubleSwitchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditAcRemoteWidget/:widgetIndex",
      name: "EditAcRemoteWidget",
      component: EditAcRemoteWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditTvRemoteWidget/:widgetIndex",
      name: "EditTvRemoteWidget",
      component: EditTvRemoteWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditTemperatureWidget/:widgetIndex",
      name: "EditTemperatureWidget",
      component: EditTemperatureWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditHumidityWidget/:widgetIndex",
      name: "EditHumidityWidget",
      component: EditHumidityWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditFolderWidget/:widgetIndex",
      name: "EditFolderWidget",
      component: EditFolderWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditSceneButtonWidget/:widgetIndex",
      name: "EditSceneButtonWidget",
      component: EditSceneButtonWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditSmartCurtainWidget/:widgetIndex",
      name: "EditSmartCurtainWidget",
      component: EditSmartCurtainWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddSingleSwitchWidget",
      name: "AddSingleSwitchWidget",
      component: AddSingleSwitchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddS1TouchWidget",
      name: "AddS1TouchWidget",
      component: AddS1TouchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddSingleThreewaySwitchWidget",
      name: "AddSingleThreewaySwitchWidget",
      component: AddSingleThreewaySwitchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/editsingleThreewaySwitchWidget/:widgetIndex",
      name: "editsingleThreewaySwitchWidget",
      component: EditSingleThreewaySwitchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddTemperatureWidget",
      name: "AddTemperatureWidget",
      component: AddTemperatureWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddHumidityWidget",
      name: "AddHumidityWidget",
      component: AddHumidityWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddFolderWidget",
      name: "AddFolderWidget",
      component: AddFolderWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddAcRemoteWidget",
      name: "AddAcRemoteWidget",
      component: AddAcRemoteWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddTvRemoteWidget",
      name: "AddTvRemoteWidget",
      component: AddTvRemoteWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddDoubleSwitchWidget",
      name: "AddDoubleSwitchWidget",
      component: AddDoubleSwitchWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddRGBWWidget",
      name: "AddRGBWWidget",
      component: AddRGBWWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditRGBWWidget/:widgetIndex",
      name: "EditRGBWWidget",
      component: EditRGBWWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddSceneButtonWidget",
      name: "AddSceneButtonWidget",
      component: AddSceneButtonWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddTemperatureAutomationWidget",
      name: "AddTemperatureAutomationWidget",
      component: AddTemperatureAutomationWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddSmartCurtainWidget",
      name: "AddSmartCurtainWidget",
      component: AddSmartCurtainWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditTemperatureAutomationWidget/:widgetIndex",
      name: "EditTemperatureAutomationWidget",
      component: EditTemperatureAutomationWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddSchedules",
      name: "AddSchedules",
      component: AddSchedules,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/EditSchedule/:scheduleIndex",
      name: "EditSchedule",
      component: EditSchedule,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Schedules",
      name: "Schedules",
      component: Schedules,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddScheduleSuccess",
      name: "AddScheduleSuccess",
      component: AddScheduleSuccess,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/AddNewWidget",
      name: "AddNewWidget",
      component: AddNewWidget,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/RGBWWidgetPalette/:index",
      name: "RGBWWidgetPalette",
      component: RGBWWidgetPalette,
      beforeEnter: function (to, from, next) {
        if (!store.state.user.loggedIn) {
          next({ path: "/" });
        } else {
          next();
        }
      },
    },
    {
      path: "/IrCodeConvertor",
      name: "IrCodeConvertor",
      component: IrCodeConvertor,
      beforeEnter: function (to, from, next) {
        next();
      },
    },
    {
      path: "/RfTester",
      name: "RfTester",
      component: RfTester,
      beforeEnter: function (to, from, next) {
        next();
      },
    },
    {
      path: "/ParameterSetter",
      name: "ParameterSetter",
      component: ParameterSetter,
      beforeEnter: function (to, from, next) {
        next();
      },
    },
  ],
});
